import ClientsDelete from "./ClientsDelete";

export default ClientsDelete;
